module.exports = __webpack_public_path__ + "img/hero-image.760ea756.png";